import { useTextCustomField } from '@atlassian/jira-issue-field-single-line-text';
import { useSummaryField } from '@atlassian/jira-issue-field-summary';
import { SUMMARY_TYPE, TEXT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { useGenericClipboardHandler } from '../../../clipboard-handler/utils';
import type { ClipboardItem, ListIssueFieldTransformed, PasteHandler } from '../../../types';
import { createClipboardHelperComponent } from '../../utils';

const getPastedValue = (clipboardItem: ClipboardItem): string | null => {
	if (!clipboardItem || !clipboardItem.plainText) {
		return null;
	}

	return clipboardItem.plainText;
};

const useSummaryClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useSummaryField({
		issueKey: issue.key,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const useTextClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useTextCustomField({
		issueKey: issue.key,
		fieldKey: field?.fieldId,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const SummaryClipboardHelper = createClipboardHelperComponent(useSummaryClipboardHandler);
const TextClipboardHelper = createClipboardHelperComponent(useTextClipboardHandler);

export const textClipboardHandler = {
	[SUMMARY_TYPE]: SummaryClipboardHelper,
	[TEXT_CF_TYPE]: TextClipboardHelper,
};
